'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TrackVisibility = require('./TrackVisibility');

var _TrackVisibility2 = _interopRequireDefault(_TrackVisibility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TrackVisibility2.default; /*
                                             * This file seems a bit useless anyway
                                             * */


//////////////////
// WEBPACK FOOTER
// ./~/react-on-screen/lib/index.js
// module id = 1283
// module chunks = 0